import { render, staticRenderFns } from "./epicofaztec.vue?vue&type=template&id=68acf80e"
import script from "./epicofaztec.vue?vue&type=script&lang=js"
export * from "./epicofaztec.vue?vue&type=script&lang=js"
import style0 from "./epicofaztec.vue?vue&type=style&index=0&id=68acf80e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports